import CustomFieldService from "@/services/api/customField";
import { handleResponse } from "@/services/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface LoadingState {
  customFields: boolean;
}

interface CustomFieldState {
  customFields: any[];
  error: string | null;
  loading: LoadingState;
}

const initialState: CustomFieldState = {
  customFields: [],
  loading: {
    customFields: false,
  },
  error: null,
};

export const getCustomFields = createAsyncThunk(
  "customFields/getCustomFields",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CustomFieldService.getCustomFields();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to fetch custom fields");
    }
  }
);

export const deleteCustomField = createAsyncThunk(
  "customFields/deleteCustomField",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await CustomFieldService.deleteCustomField(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to delete custom field");
    }
  }
);

export const addCustomField = createAsyncThunk(
  "customFields/addCustomField",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await CustomFieldService.addCustomField(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to add custom field");
    }
  }
);

export const updateCustomField = createAsyncThunk(
  "customFields/updateCustomField",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await CustomFieldService.updateCustomField(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to update custom field");
    }
  }
);

const customFieldSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomFields.pending, (state) => {
        state.loading.customFields = true;
        state.customFields = [];
      })
      .addCase(getCustomFields.fulfilled, (state, action) => {
        state.loading.customFields = false;
        state.customFields = action.payload || [];
      })
      .addCase(getCustomFields.rejected, (state, action) => {
        state.loading.customFields = false;
        state.error = action.payload as string;
      });
  },
});

export default customFieldSlice.reducer;
